import { makeStyles } from '@material-ui/core/styles';
import SpeedDial from '@material-ui/lab/SpeedDial';
import SpeedDialAction from '@material-ui/lab/SpeedDialAction';
import SpeedDialIcon from '@material-ui/lab/SpeedDialIcon';
import * as PropTypes from 'prop-types';
import React, { useState } from 'react';
import { TabActionsContainer } from './styles';

const useStyles = makeStyles((theme) => ({
  root: {
    /* Esses estilos foram desabilitados para que os botoes da acao geral nao sumam
     * da tela dependendo da resolucao. Com isso, os botoes podem sobrepor o cabeçalho
     * dos grids.
     * transform: 'translateZ(0px)',
     * flexGrow: 1,
     * zIndex: 10000,
     * */
    // [theme.breakpoints.down('md')]: {
    //   position: 'absolute',
    //   bottom: theme.spacing(2),
    //   right: theme.spacing(4),
    //   backgroundColor: 'red',
    // },
  },
  speedDial: {
    position: 'absolute',
    '&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft': {
      bottom: theme.spacing(2),
      right: theme.spacing(2),
    },
    '&.MuiSpeedDial-directionDown, &.MuiSpeedDial-directionRight': {
      top: theme.spacing(2),
      left: theme.spacing(2),
    },
  },
}));

const useStylesTooltip = makeStyles({
  tooltip: {
    fontSize: '1.4rem',
  },
});

function TableActions({ actions, direction, hidden, className }) {
  const classes = useStyles();
  const classesTooltip = useStylesTooltip();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <TabActionsContainer className={classes.root}>
      <SpeedDial
        ariaLabel="TableActions"
        className={classes.speedDial}
        hidden={hidden}
        icon={<SpeedDialIcon className={className} />}
        onClose={handleClose}
        onOpen={handleOpen}
        open={open}
        direction={direction}
      >
        {actions
          .filter((action) => action.show === undefined || action.show === true)
          .map((action) => (
            <SpeedDialAction
              FabProps={{
                style: {
                  backgroundColor: action.disabled && 'rgb(157,157,157,0.8)',
                  color: action.disabled && 'white',
                  cursor: action.disabled && 'default',
                },
              }}
              key={action.name}
              icon={action.icon}
              tooltipTitle={action.disabled || action.tooltip}
              TooltipClasses={classesTooltip}
              onClick={(event) => {
                try {
                  handleClose();
                } finally {
                  action.onClick(event);
                }
              }}
            />
          ))}
      </SpeedDial>
    </TabActionsContainer>
  );
}

TableActions.propTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.node,
      name: PropTypes.string,
      tooltip: PropTypes.string,
      show: PropTypes.bool,
      onClick: PropTypes.func,
    })
  ),
  direction: PropTypes.oneOf(['up', 'down', 'right', 'left']),
  hidden: PropTypes.bool,
};

TableActions.defaultProps = {
  actions: null,
  direction: 'up',
  hidden: false,
};

export default TableActions;
